import React from "react"
import "./icon.scss"

const BurgerIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48">
    <path d="M6 36h36v-4H6v4zm0-10h36v-4H6v4zm0-14v4h36v-4H6z"></path>
  </svg>
)

export default BurgerIcon
